import { api } from '@/services'

export const findAll = (params) => {
  return api.get('/web/realEstateUser/list', { params })
}

export const findById = (realEstateUserId) => {
  return api.get(`/web/realEstateUser/findById/${realEstateUserId}`)
}

export const create = (payload) => {
  return api.post('/web/realEstateUser/create', payload)
}

export const update = (id, payload) => {
  return api.post(`/web/realEstateUser/update/${id}`, payload)
}

export const remove = (realEstateUserId) => {
  return api.delete(`/web/realEstateUser/delete/${realEstateUserId}`)
}

export const updateRealEstateUserPassword = (body) => {
  return api.post('/web/realEstateUser/updatePassword', body)
}
